import styles from './styles.module.scss'

type FormGridProps = {
  children: React.ReactNode
  column?: 'single' | 'double'
  gap?: 'large' | 'medium' | 'small'
}

export default function FormGrid({
  children,
  gap = 'medium',
  column = 'single'
}: FormGridProps) {
  return (
    <div className={`${styles.FormGrid} ${styles[column]} ${styles[gap]}`}>
      {children}
    </div>
  )
}
